import React, { useState } from "react";
import { Tab } from "./types";
import EditorView from "./EditorView";
import HtmlView from "./HtmlView";
import PreviewView from "./PreviewView";
import { useFormattedHtml } from "../../../hooks/useFormattedHtml";

import {
  Card,
  CardContent,
  Tabs,
  Tab as MuiTab,
  Divider,
} from "@mui/material";

interface TextEditorProps {
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
}

const TextEditor: React.FC<TextEditorProps> = ({ value, onChange, disabled  }) => {
  const [activeTab, setActiveTab] = useState<Tab>(Tab.Editor);
  const formattedHtml = useFormattedHtml(value, activeTab === Tab.Html);

  const handleTabChange = (_: React.SyntheticEvent, newValue: Tab) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case Tab.Editor:
        return <EditorView value={value} onChange={onChange}  disabled={disabled}/>;
      case Tab.Html:
        return <HtmlView value={formattedHtml} onChange={onChange} disabled={disabled} />;
      case Tab.Preview:
        return <PreviewView html={value} />;
      default:
        return null;
    }
  };

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        sx={{ px: 2, pt: 1 }}
      >
        {Object.values(Tab).map((tab) => (
          <MuiTab
            key={tab}
            value={tab}
            label={tab.charAt(0).toUpperCase() + tab.slice(1)}
          />
        ))}
      </Tabs>
      <Divider />
      <CardContent sx={{ p: 2 }}>{renderTabContent()}</CardContent>
    </Card>
  );
};

export default TextEditor;
